<template>
  <div class="">
    <div class="table-page-search-wrapper">
      <a-row :gutter="12" style="margin:16px 25px;">
        <a-col class="a-large-form" >
          <a-form-item label="" style="margin-bottom:0px">
            <a-input placeholder="请输入学员名称" style="width:100%" v-model="queryParam.realname"></a-input>
          </a-form-item>
        </a-col>
        <a-button @click="searchQuery" type="primary" style="margin-left:5px;vertical-align: middle;">筛选</a-button>

      </a-row>
    </div>
    <div>
      <a-table
        ref="table"
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading">

      </a-table>
    </div>
  </div>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'

  export default {
    name: 'OnlineUserList',
    components: {

    },
    mixins: [JeecgListMixin],
    data() {
      return {
        firstIsNotLoad: true,
        queryParam: {
          chId: '',
          name: ''
        },
        loading: false,
        visible: false,
        description: '学员名单',
        url: {
          list: '/magic/liveCourse/roomFlow',
          delete: '/course/edit/delete',
          deleteBatch: '/course/elinkxCourse/deleteBatch',
          exportXlsUrl: 'course/elinkxCourse/exportXls',
          importExcelUrl: 'course/elinkxCourse/importExcel'
        },
        columns: [
          {
            title: '用户名称',
            align: 'left',
            dataIndex: 'realname',
            width: 120
          },
          {
            title: '首次进入时间',
            align: 'center',
            dataIndex: 'fistTime',
            width: 120
          },
          {
            title: '观看时长',
            align: 'center',
            dataIndex: 'sec',
            width: 120
          }
        ],
        dataSource: [
        ]
      }
    },

    created() {
      this.queryParam.chId = this.$route.query.chId
      this.loadData()
      // alert(this.queryParam.courseId)
      // console.log("123");
    },

    methods: {
      // 新增章节
      courseChapterCreate() {
        this.$router.push({ path: '/myCourse/courseChapterCreate?courseId=' + this.queryParam.courseId })
      },

      // 删除章节
      courseChapterDel(chapterIdPram) {
        deleteChapter({ id: chapterIdPram }).then((res) => {
          if (res.code == 0) {
            this.$message.success(res.message)
            this.loadData()
          } else {
            this.$message.warning(res.message)
          }
        }).finally(() => {

        })
      },

      // 编辑章节
      courseChapterEdite(chapterIdPram) {
        this.$router.push({ path: '/myCourse/courseChapterCreate?chapterId=' + chapterIdPram + '&courseId=' + this.queryParam.courseId })
      },
      // 课时上下架
      chapterShelf(chapterIdParam) {
        chapterShelf({ id: chapterIdParam }).then((res) => {
          if (res.success == true) {
            this.$message.success(res.message)
            this.loadData()
          } else {
            this.$message.warning(res.message)
          }
        }).finally(() => {

        })
      },

      // 创建课时
      courseHoursCreate(id) {
        // this.visible = true;
        this.$refs.courseTypeSelectModal.add(id)
      },

      // 编辑课时
      courseHoursEdite(item) {
        // this.visible = true;
        if (item.chType == '1') {
          this.$router.push({ path: '/myCourse/pictureBookCreate?courseId=' + this.queryParam.courseId + '&id=' + item.id + '&chapterId=' + item.chapterId })
        } else if (item.chType == '2') {
          this.$router.push({ path: '/myCourse/videoCreate?courseId=' + this.queryParam.courseId + '&id=' + item.id + '&chapterId=' + item.chapterId })
        } else if (item.chType == '3') {
          this.$router.push({ path: '/myCourse/imageTextCreate?courseId=' + this.queryParam.courseId + '&id=' + item.id + '&chapterId=' + item.chapterId })
        } else if (item.chType == '4') {
          this.$router.push({ path: '/myCourse/audioCreate?courseId=' + this.queryParam.courseId + '&id=' + item.id + '&chapterId=' + item.chapterId })
        } else if (item.chType == '5') {
          this.$router.push({ path: '/myCourse/gameHourCreate?courseId=' + this.queryParam.courseId + '&id=' + item.id + '&chapterId=' + item.chapterId })
        }
      },

      // 删除课时
      courseHoursDel(item) {
        deleteCourseHour({ id: item.id }).then((res) => {
          if (res.code == 0) {
            this.$message.success(res.message)
            this.loadData()
          } else {
            this.$message.warning(res.message)
          }
        }).finally(() => {

        })
      }

    }
  }
</script>

<style scoped>

</style>
